// extracted by mini-css-extract-plugin
export default {"cls1":"RBr8ejOYBeQG8KE8lDkr","cls2":"jNQNWDfkhhZwO7H28XxO RBr8ejOYBeQG8KE8lDkr"};